export enum PaymentType {
  EMI = 'EMI',
  CUSTOM = 'CUSTOM',
  FORECLOSURE = 'FORECLOSURE',
  EARLY_PAYMENT = 'EARLY_PAYMENT'
}

export type PaymentPayload = {
  type: PaymentType;
  loanAccountNumber: string;
  customAmount?: string;
  phoneNumber: string;
  phoneNumberCustomId?: string;
};
